<template>
  <div class="centered login-wrapper">
    <DataLoader :is_on="$store.state.login_load" />
    <div class="login-flex-wrapper">
      <div class="login-helper"></div>
      <div class="login-center">
        <div class="legalleria-login-logo"><img class="legalleria" src="@/assets/img/legalleria.svg" alt="MS logo">
        </div>
        <h1 class="legalleria-login-txt"> {{ isBrave ? $t("login.login_1") : isIE ? $t("login.login_2") : $t("login.login_3")}}
        </h1>
        <button v-if="!isBrave && !isIE" class="button glow-on-hover microsoft-button is-large" @click="doLogin">
          {{ $t("login.login_btn") }} <img class="ml-4" src="@/assets/mssymbol.svg" alt="MS logo">
        </button>
        <button v-if="isBrave" class="button glow-on-hover microsoft-button is-large" @click="isBrave = false">
          {{$t("repetitive.okay")}}
        </button>
      </div>
      <p class="legalleria-login-bottom-txt">
        {{ $t("login.login_msg") }}
      </p>
      <!-- <div class="brave-warning" v-if="isBrave">
        <div class="picture-text-wrapper">
          <div class="brave-text-button">
            <span>Koristite Brave preglednik. Ukoliko imate uključen Brave Shields molimo da ga isključite za nesmetano korištenje aplikacije</span>
          </div>  
          <img src="@/assets/img/brave_warning.png" />
        </div>

      </div> -->
      <!-- <div v-if="isBrave" class="notification is-warning mt-4">
        {{ tenkre_msg }}
      </div> -->
    </div>
    <div class="fourth_row">
      <div class="fr-left">
        <a target="_blank" href="https://strukturnifondovi.hr/"><div class="first-eu-logo"><img src="@/assets/img/EU-NEXT-GEN.jpg"></div></a>

      <div class="eu-txt1"><p>{{ $t("login.sufinanced1") }}</p>
        <p>{{ $t("login.sufinanced2") }}</p>
      </div>
        <div class="eu-txt2"><p>{{ $t("login.contact") }} Marko Porobija, Suzana Cesarec Nöthig</p>
          <p><a href="mailto:info@psod.hr">info@psod.hr</a></p>
        </div>
      </div>
      <div class="fr-right">

        <a target="_blank" href="https://strukturnifondovi.hr/"><div class="eu-logos"><img src="@/assets/img/footer-logos.svg"></div></a>
      </div>
    </div>
  </div>
</template>


<script>
import {signIn} from '@/services/auth/redirectLogin'
import DataLoader from '@/components/generalComponents/DataLoader'

export default {
  components:{
    DataLoader
  },
  data: function () {
    return {
      error: '',
      isBrave: false,
      isIE: false,
      tenkre_msg : "Ili imaš maloga ili su ti cecke obešene kad koristiš Brave. Odi na chrome."
    }
  },

  methods: {
    detectNonAndroidPhone() {
      const toMatch = [
          /iPhone/i,
          /iPad/i,
          /iPod/i,
          /BlackBerry/i,
          /Windows Phone/i
      ];
      
      return toMatch.some((toMatchItem) => {
          return window.navigator.userAgent.match(toMatchItem);
      });
    },
    async doLogin() {
     await signIn().then(() => {
            // this.$router.push({ path: "/" })
          });
    //   var ua = window.navigator.userAgent;


    //   auth.configure(process.env.VUE_APP_CLIENT_ID)
    //   console.log("IEXPL", ua.indexOf("MSIE"), "Safari", ua.indexOf("Safari"), "Chrome", ua.indexOf("Chrome"), "Mozilla", ua.indexOf("Mozilla"));

    //   if (this.detectNonAndroidPhone()) {
    //     try {
    //       await auth.login().then(() => {
    //         this.$router.push({ path: "/" });
    //       })
    //     } catch (err) {
    //       this.error = err.toString()
    //     }
    //   }
    //   else if (ua.indexOf("Chrome") > -1) {
    //     try {
    //       await auth.login().then(() => {
    //         this.$router.push({ path: "/" })
    //       })
    //     } catch (err) {
    //       this.error = err.toString()
    //     }
    //   }

    //  else if (ua.indexOf("Brave") > -1) {
    //     try {
    //       await auth.login().then(() => {
    //         this.$router.push({ path: "/" })
            
            
    //       })
    //     } catch (err) {
    //       this.error = err.toString()
    //     }
    //   }
    //   else if (ua.indexOf("MSIE") > -1 || ua.indexOf("Safari") > -1) {
    //     try {
    //       await auth.popupLogin().then(() => {
    //         this.$router.push({ path: "/" })
    //       })
    //     } catch (err) {
    //       this.error = err.toString()
    //     }
    //   } else {
    //     try {
    //       await auth.login().then(() => {
    //         this.$router.push({ path: "/" })
    //       })
    //     } catch (err) {
    //       this.error = err.toString()
    //     }
    //   }

    }
  },
  async created() {

    if (navigator.brave && await navigator.brave.isBrave() || false) {
      this.isBrave = true;
    };
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      isIE = false;
    }
  },
}
</script>

<style scoped>
.centered {
  text-align: center;
}
</style>